import React from "react";
import AdBar from "@/components/Ads/AdBar";
import Seo from "@/components/seo";

import styles from "./DefaultPage.module.css";

export default class DefaultPage extends React.Component {
  // constructor(props) {
  //   super(props);

  //   this.headings = ["", ""];
  //   this.state = { contents: ["", ""] };
  // }

  render() {
    const { headings, contents } = this.props;

    return (
      <div className="container">
        <Seo
          title={`${headings[0][0]}${headings[0]
            .substring(1)
            .toLowerCase()} Us`}
        />
        <div id="about-section">
          <div className={styles.heading}>
            <h2>{headings[0]}</h2>
          </div>
          {/* <div className="content" id="top-about-ad">
                    <div id="dfp-ad-kvrx_toprectangle_300x250-wrapper" className="dfp-tag-wrapper">
                        <div id="dfp-ad-kvrx_toprectangle_300x250" className="dfp-tag-wrapper">
                            <script type="text/javascript">
                                googletag.cmd.push(function () {
                                    googletag.display("dfp-ad-kvrx_toprectangle_300x250");
                                });
                        </script>
                        </div>
                    </div>
                </div> */}

          <div dangerouslySetInnerHTML={{ __html: contents[0] }} />

          <AdBar />
          <div className={styles.heading}>
            <h2>{headings[1]}</h2>
          </div>
          {/* <div id="lower-about-ads">
                <div className="content" id="mid-about-ad">
                <div id="dfp-ad-kvrx_middlerectangle_300x250-wrapper" className="dfp-tag-wrapper">
                <div id="dfp-ad-kvrx_middlerectangle_300x250" className="dfp-tag-wrapper">
                <script type="text/javascript">
                googletag.cmd.push(function () {
                  googletag.display("dfp-ad-kvrx_middlerectangle_300x250");
                });
                </script>
                </div>
                </div>
                </div>
                
                <div className="content" id="bottom-about-ad">
                <div id="dfp-ad-kvrx_bottomrectangle_300x250-wrapper" className="dfp-tag-wrapper">
                <div id="dfp-ad-kvrx_bottomrectangle_300x250" className="dfp-tag-wrapper">
                <script type="text/javascript">
                googletag.cmd.push(function () {
                  googletag.display("dfp-ad-kvrx_bottomrectangle_300x250");
                });
                </script>
                </div>
                </div>
                </div>
              </div> */}

          <div dangerouslySetInnerHTML={{ __html: contents[1] }} />
        </div>
      </div>
    );
  }
}
